import {config} from "./config"

class Cookie {

	/**
	 * Вернет значение куки с под именем name
	 * @param name - имя куки
	 * @return значение или undefined
	 *
	 * УСТАНАВЛИВАЯ КУКИСЫ ПОМНИ, ВСЕ ОНИ ДОЛЖНЫ НАЧИНАТЬСЯ С ПРЕФИКСА РЕГИОНА ПЛЮС НИЖНЕЕ ПОДЧЕРКИВАНИЕ
	 * НАПРИМЕР: msk_sid
	 * ПРИ ЗАПРОСЕ КУКИСА ПРЕФИКС ДОБАВЛЯЕТСЯ К ИМЕНИ АВТОМАТИЧЕСКИ
	 * ПРИ СОЗДАНИ ДОБАВЛЕНИЯ ПРЕФИКСА НА СОВЕСТИ СОЗДАТЕЛЯ
	 * ИМЕНА БЕЗ ПРЕФИКСА НЕ БУДУТ НАЙДЕНЫ
	 */

	static get(name) {
		let coocies = document.cookie.split(";").map(value => value.trim().split("="))
		for (let cookie of coocies) {
			if (cookie[0] === `${config.region.prefix}_${name}`) {
				return cookie[1]
			}
		}
		return undefined
	}

}

export default Cookie
